// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.actions[data-v-c8993b94]{\r\n\t-ms-flex-wrap: nowrap;\r\n\t    flex-wrap: nowrap;\n}\n.actions>*[data-v-c8993b94]:not(:last-child){\r\n\tmargin-right: 5px;\n}\n.search-chip[data-v-c8993b94] {\r\n\toverflow-y: hidden;\n}\r\n\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
